/*
 * @Descripttion: 实现desktop和mobile共享组件的loading指令
 * @Author: zenghua.wang
 * @Date: 2021-10-21 14:28:45
 * @LastEditors: zenghua.wang
 * @LastEditTime: 2021-11-26 09:23:39
 */
import Vue from "vue"
import CustomLoading from "./loading.vue"

const Mask = Vue.extend(CustomLoading)

// 更新是否显示
const toggleLoading = (el, binding) => {
  if (binding.value) {
    Vue.nextTick(() => {
      el.instance.visible = true
      el.appendChild(el.mask)
      if (el.instance.lock) document.body.style.overflow = "hidden"
    })
  } else {
    // 如果传入的值是 false，或是没有值，就销毁 Mask
    el.instance.visible = false
    if (el.instance.lock) document.body.style.overflow = "auto"
    el.mask && el.mask.parentNode && el.mask.parentNode.removeChild(el.mask)
    el.instance && el.instance.$destroy()
  }
}

export default {
  bind: function(el, binding, vnode) {
    let text = el.getAttribute("custom-loading-text")
    let spinner = el.getAttribute("custom-loading-spinner")
    let background = el.getAttribute("custom-loading-background")
    let customClass = el.getAttribute("custom-loading-class")
    let lock = el.getAttribute("custom-loading-lock")
    const mask = new Mask({
      el: document.createElement("div"),
      data: {
        text: text || "加载中…",
        spinner: spinner || "el-icon-loading",
        background: background || "rgba(255, 255, 255, 0)",
        customClass: customClass || "",
        lock: lock || false,
      },
    })
    el.instance = mask
    el.mask = mask.$el
    el.maskStyle = {}
    binding.value && toggleLoading(el, binding)
  },
  update: function(el, binding) {
    el.instance.setText(el.getAttribute("cunstom-loading-text"))
    if (binding.oldValue !== binding.value) {
      toggleLoading(el, binding)
    }
  },
  unbind: function(el, binding) {
    el.mask && el.mask.parentNode && el.mask.parentNode.removeChild(el.mask)
    el.instance && el.instance.$destroy()
  },
}
